import { Form, Formik } from 'formik';
import { ButtonPrimary } from '../../components/Button/ButtonPrimary';
import { ErrorMessageLabel } from '../../components/ErrorMessageLabel/ErrorMessageLabel';
import { InputField } from '../../components/InputField/InputField';
import { StorageRoom } from '../../../models/Storage/StorageRoom';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

function CreateStorageRoom() {
  return (
    <>
      <h1 className="cs-title">Dodaj Skladišnu Soba</h1>
      <Formik
        initialValues={{ name: '' }}
        validationSchema={Yup.object({
          name: Yup.string().required('Naziv je obavezan')
        })}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          StorageRoom.store(values)
            .then(() => {
              resetForm();
              toast.success('Soba je uspešno dodata!');
            })
            .catch((error) => {
              toast.error(
                error?.response?.data?.message || 'Greška pri snimanju.'
              );
            })
            .finally(() => setSubmitting(false));
        }}
      >
        {({ isSubmitting }) => (
          <Form autoComplete="off" className="cs-form-wrapper">
            <FormGroup>
              <Col lg={6}>
                <FormLabel>Naziv sobe</FormLabel>
                <InputField placeholder="Naziv sobe" name="name" />
                <ErrorMessageLabel name="name" />
              </Col>
            </FormGroup>
            <ButtonPrimary type="submit" disabled={isSubmitting}>
              Sačuvaj
            </ButtonPrimary>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default CreateStorageRoom;
